/* eslint-disable */ 
import React from 'react';

function ProgramsSectionItem({ program }) {
    return (
        <div className="card">
            <div className="image_wrapper">
                <img src={`${process.env.PUBLIC_URL}/images/${program.image}`} alt="" />
            </div>
            <div className="card_body">
                <h4 className="card_header">
                    {program.title}
                </h4>
                <div className="card_detail">
                    <p className="card_detail_list_item card_detail_header">
                        Includes the following micro-credentials:
                    </p>
                    <ul className="card_detail_list">
                        {program.details.map(detail => (
                            <li className="card_detail_list_item" key={detail}>
                                {detail}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="card_detail">
                    <p className="card_detail_list_item card_detail_header">
                        Plus a choice of 2 from these micro-credentials
                    </p>
                    <ul className="card_detail_list">
                        {program.plus_choice.map(choice => (
                            <li className="card_detail_list_item" key={choice}>
                                {choice}
                            </li>
                        ))}
                    </ul>
                </div>
                <button className="btn">
                    Enrol now
                    <img src={`${process.env.PUBLIC_URL}/images/Arrow_Forward.png`} alt="arrow icon" className="btn_icon" />
                </button>
            </div>
        </div>
    );
}

export default ProgramsSectionItem;